module.exports = __webpack_public_path__ + "img/landing_box19.2cd08a5c.jpg";